import { PrimaryNavBuilderType } from "src/assets/Types/Redesign/PrimaryNavMenuType.type";
import DesktopNavBarContent from "./DesktopNavBar/DesktopNavBar";

import NavMobile from "./NavMobile/NavMobile";
import React from "react";

const PrimaryNavMenu: React.FC<PrimaryNavBuilderType> = ({
  onClickHandler,
  noSticky = false,
  hiddenMobile,
  hiddenDesktop,
}) => {
  return (
    <>
      <DesktopNavBarContent
        onClickHandler={onClickHandler}
        noSticky={noSticky}
        hiddenDesktop={hiddenDesktop}
      />
      {!hiddenMobile && (
        <NavMobile
          onClickHandler={onClickHandler}
          hiddenMobile={hiddenMobile}
        />
      )}
    </>
  );
};
export default PrimaryNavMenu;
